import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, { ReactNode, ReactNodeArray } from 'react';
import LobbyCellphone from './LobbyCellphone.js';
import HeaderLobbyCellphoneBlockData from 'app/Models/Content/HeaderLobbyCellphoneBlockData.js';

export default class HeaderLobbyCellphoneBlock extends EpiComponent<HeaderLobbyCellphoneBlockData> {

  public render(): ReactNode | ReactNodeArray | null {
    const cssClasses: Array<string> = ['header-lobby-cellPhone-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <LobbyCellphone
          context={this.getContext()}
          iContent={this.props.data}
        />
      </div>
    );
  };
};
